export const WelcomeExtension = () => {
  window.location.href = "Welcome/extension.html";
  return <></>;
};